module.exports = __webpack_public_path__ + "img/bottom_store.6eb6dbe7.png";